import {useEffect, useState} from 'react'

import {fetchCharterReadAt} from '../api'

/**
 * Whether the connected account has a charter reading on record. `undefined`
 * while the answer is not in, and when asking for it failed.
 */
export function useCharterReading(): boolean | undefined {
  const [hasRead, setHasRead] = useState<boolean | undefined>()

  useEffect(() => {
    let isCurrent = true

    const load = async () => {
      try {
        const readAt = await fetchCharterReadAt()

        if (isCurrent) {
          setHasRead(readAt !== undefined)
        }
      } catch {
        // Nothing to do: `undefined` already says the answer is missing, and the
        // notice keeps inviting to read. A failed request costs the acknowledgement
        // of a past reading, never the access to the charter.
      }
    }

    void load()

    return () => {
      isCurrent = false
    }
  }, [])

  return hasRead
}
